/**
 * Attempts to open native maps app based the device's platform
 *
 * @export
 * @param {*} query
 * @param {*} [coords=null]
 */
export default function openMap(query = '', lat = 0, lon = 0) {
  let params = []
  let url = ''

  // If we're on iOS/OSX, open in Apple Maps
  if (
    navigator.platform.indexOf('MacIntel') != -1 ||
    navigator.platform.indexOf('iPhone') != -1 ||
    navigator.platform.indexOf('iPad') != -1 ||
    navigator.platform.indexOf('iPod') != -1
  ) {
    if (query) params.push(`q=${encodeURIComponent(query)}%2080920`)
    if (lat && lon) params.push(`ll=${lat},${lon}`)
    url = `http://maps.apple.com/?${params.join('&')}`
  }
  // else use Google
  else {
    if (lat && lon && query) {
      params.push(`query_place_id=${encodeURIComponent()}&query=${lat},${lon}`)
    } else if (query) {
      params.push(`query=${encodeURIComponent(query)}`)
    }
    url = `https://www.google.com/maps/search/?api=1&${params.join('&')}`
  }

  return url
}
